/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DiscoveryJob } from '../models/DiscoveryJob';

export class DiscoveryStatusResponse {
  'lastJob': DiscoveryJob;
  'lastCompletedJob': DiscoveryJob;
  /**
  * Indicates whether the onboarding discovery process has finished
  */
  'finished': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "lastJob",
      "baseName": "lastJob",
      "type": "DiscoveryJob",
      "format": ""
    },
    {
      "name": "lastCompletedJob",
      "baseName": "lastCompletedJob",
      "type": "DiscoveryJob",
      "format": ""
    },
    {
      "name": "finished",
      "baseName": "finished",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DiscoveryStatusResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

